@if (loggedIn) {
  <div class="header-content">
    @if (rights.includes('CarrierPortal')) {
      <mat-toolbar color="primary" class="unified-header-toolbar">
        <span class="rb-logo-non-button">
          @if (unitLogo) {
            <span class="unified-logo" [innerHTML]="unitLogo"></span>
          } @else {
            <img
              src="{{ './assets/' + logoName }}"
              alt="Application Logo Home Button"
              class="unified-logo"
            />
          }
        </span>

        <button
          class="menu-button"
          type="button"
          mat-button
          [matMenuTriggerFor]="userMenu"
        >
          <span class="username">
            {{ user?.firstname }} {{ user?.lastname }}
          </span>
          <mat-icon>account_circle</mat-icon>
        </button>
        <mat-menu
          #userMenu="matMenu"
          direction="down"
          yPosition="below"
          class="unified-menu"
        >
          <button
            type="button"
            mat-menu-item
            id="logout-item"
            (click)="logout()"
          >
            <mat-icon>logout</mat-icon> Logout
          </button>
        </mat-menu>
      </mat-toolbar>
    } @else {
      <mat-toolbar
        color="primary"
        class="unified-header-toolbar"
        [class.proxy-active]="proxyActive"
      >
        <button
          type="button"
          class="home-button"
          (click)="goToPage('homepage')"
        >
          @if (unitLogo) {
            <span class="unified-logo" [innerHTML]="unitLogo"></span>
          } @else {
            <img
              src="{{ './assets/' + logoName }}"
              alt="Application Logo Home Button"
              class="unified-logo"
            />
          }
        </button>

        <app-utility-apps />

        @if (proxyActive) {
          <button
            type="button"
            mat-button
            class="proxy"
            [matTooltip]="
              user.firstname +
              ' ' +
              user.lastname +
              ' Currently proxying for: ' +
              proxyData.name +
              ' click to end.'
            "
            (click)="endProxy()"
          >
            <mat-icon>co_present</mat-icon>: {{ proxyData.name }}
          </button>
        }
        <button
          type="button"
          mat-button
          class="menu-button"
          [matMenuTriggerFor]="userMenu"
        >
          <span class="username">
            {{ user?.firstname }} {{ user?.lastname }}
          </span>
          <mat-icon>account_circle</mat-icon>
        </button>
        <mat-menu
          #userMenu="matMenu"
          direction="down"
          yPosition="below"
          class="unified-menu"
        >
          @if (isAdmin) {
            <button
              type="button"
              mat-menu-item
              id="admin-item"
              [matMenuTriggerFor]="adminMenu"
            >
              <mat-icon>admin_panel_settings</mat-icon> Admin
            </button>
          }
          @if (reporting) {
            <button
              type="button"
              mat-menu-item
              id="reporting-item"
              routerLink="/reporting"
            >
              <mat-icon>assessment</mat-icon>
              Reporting
            </button>
          }
          @if (automatedReportPage) {
            <button
              type="button"
              mat-menu-item
              id="automated-reports"
              routerLink="/automated-reports"
              ><mat-icon>summarize</mat-icon>Automated Reports</button
            >
          }
          @if (ProxyinMenu && !proxyActive) {
            <button
              type="button"
              mat-menu-item
              id="proxy-item"
              (click)="proxy()"
            >
              <mat-icon>co_present</mat-icon> Proxy
            </button>
          }
          @if (proxyActive) {
            <button
              type="button"
              mat-menu-item
              id="end-proxy-item"
              (click)="endProxy()"
            >
              <mat-icon>dangerous</mat-icon> End Proxy
            </button>
          }
          @if (toolsLandingPage) {
            <button
              type="button"
              mat-menu-item
              id="tools-item"
              routerLink="/tools"
            >
              <mat-icon>handyman</mat-icon> Tools
            </button>
          }
          @if (displayHelp && displayHelpMenu) {
            <button
              type="button"
              mat-menu-item
              id="help-menu-item"
              [matMenuTriggerFor]="helpMenu"
              (click)="getHelp(null, 'rb')"
            >
              <mat-icon>help</mat-icon> Help
            </button>
          }
          @if (displayHelp && !displayHelpMenu) {
            <button
              type="button"
              mat-menu-item
              id="help-item"
              [ngClass]="{ disabled: noLink }"
              (click)="getHelp(null, 'rb')"
            >
              <mat-icon>help</mat-icon> Help
            </button>
          }
          @if (isAdmin) {
            <button
              type="button"
              mat-menu-item
              id="tech-notes-item"
              (click)="openTechNotes()"
            >
              <mat-icon>edit_note</mat-icon> Tech Notes
            </button>
          }
          <button
            type="button"
            mat-menu-item
            id="settings-item"
            routerLink="/settings"
            [disabled]="true"
          >
            <mat-icon>manage_accounts</mat-icon> User Settings
          </button>
          <button
            type="button"
            mat-menu-item
            id="logout-item"
            (click)="logout()"
          >
            <mat-icon>logout</mat-icon> Logout
          </button>
        </mat-menu>
        <mat-menu #adminMenu="matMenu">
          @if (isAdmin && rights.includes('RolesAndRights')) {
            <button
              type="button"
              mat-menu-item
              id="roles-rights-item"
              routerLink="/admin/roles-rights"
            >
              <mat-icon>lock_person</mat-icon>Roles/Rights
            </button>
          }
          @if (isAdmin && rights.includes('UnitProfile')) {
            <button
              type="button"
              mat-menu-item
              id="unit-profile-item"
              routerLink="/admin/unit-profile"
            >
              <mat-icon>source</mat-icon>Unit Profiles
            </button>
          }
          @if (isAdmin && rights.includes('RepManagement')) {
            <button
              type="button"
              mat-menu-item
              id="rep-management-item"
              routerLink="/admin/rep-management"
            >
              <mat-icon>perm_contact_calendar</mat-icon>Rep Management
            </button>
          }
          @if (isAdmin && rights.includes('UserManagement')) {
            <button
              type="button"
              mat-menu-item
              id="user-management-item"
              routerLink="/admin/user-management"
            >
              <mat-icon>people_alt</mat-icon>User Management
            </button>
          }
          @if (isAdmin && rights.includes('Unit')) {
            <button
              type="button"
              mat-menu-item
              id="unit-item"
              routerLink="/admin/unit-management"
            >
              <mat-icon>home_work</mat-icon>Unit Management
            </button>
          }
          @if (isAdmin && rights.includes('KnowledgeBase')) {
            <button
              type="button"
              mat-menu-item
              id="knowledge-base-item"
              routerLink="/admin/uploads"
            >
              <mat-icon>upload</mat-icon>Uploads
            </button>
          }
          @if (isAdmin) {
            <button
              type="button"
              mat-menu-item
              id="knowledge-base-history-item"
              routerLink="/admin/kb-change-history"
            >
              <mat-icon>timeline</mat-icon>KB Changes
            </button>
          }
          @if (isAdmin && rights.includes('ContentUpload')) {
            <button
              type="button"
              mat-menu-item
              id="content-management-item"
              routerLink="/admin/content-management"
            >
              <mat-icon>storage</mat-icon>Content Management
            </button>
          }
          @if (isAdmin && rights.includes('LegacyReport')) {
            <div>
              <form
                action="{{ ceteraAction }}"
                ngNoForm
                method="post"
                enctype="multipart/form-data"
              >
                <input value="{{ session }}" type="text" hidden name="X_RB_u" />
                <button mat-menu-item id="legacy-report-item" type="submit"
                  ><mat-icon>collections_bookmark</mat-icon>Legacy
                  Reports</button
                >
              </form>
            </div>
          }
          @if (isAdmin && rights.includes('Toolbox')) {
            <button
              type="button"
              mat-menu-item
              id="toolbox-item"
              routerLink="/admin/toolbox"
            >
              <mat-icon>home_repair_service</mat-icon>Toolbox
            </button>
          }
        </mat-menu>
        <mat-menu #helpMenu="matMenu">
          @if (displayHelp && rights.includes('PPHelp')) {
            <button
              type="button"
              mat-menu-item
              id="pp-help-item"
              (click)="
                getHelp(
                  'https://www.help.rightbridge.net/productprofiler',
                  'pp'
                )
              "
            >
              <mat-icon class="me-0" svgIcon="pp_icon" /> Product Profiler
            </button>
          }
          @if (displayHelp && rights.includes('AWHelp')) {
            <button
              type="button"
              mat-menu-item
              id="aw-help-item"
              (click)="
                getHelp('https://www.help.rightbridge.net/annuitywizard', 'aw')
              "
            >
              <mat-icon class="me-0" svgIcon="aw_icon" /> Annuity Wizard
            </button>
          }
          @if (displayHelp && rights.includes('IWHelp')) {
            <button
              type="button"
              mat-menu-item
              id="iw-help-item"
              (click)="getHelp(null, 'iw')"
            >
              <mat-icon class="me-0" svgIcon="iw_icon" /> Investment Wizard
            </button>
          }
          @if (displayHelp && rights.includes('LIHelp')) {
            <button
              type="button"
              mat-menu-item
              id="li-help-item"
              (click)="getHelp(null, 'li')"
            >
              <mat-icon class="me-0" svgIcon="lw_icon" /> Life Insurance Wizard
            </button>
          }
        </mat-menu>
      </mat-toolbar>
    }

    @if (rights.includes('HolidayMode')) {
      <app-holiday-decor />
    }
  </div>
}
